<div class="container">
  <app-courses-list
    *ngIf="activeTab === 'courses'"
    [user]="user"
    [selectedYearChoice]="selectedYearChoice"
    [disableEditingDueToYear]="disableEditingDueToYear"
  ></app-courses-list>

  <app-requirements-list
    *ngIf="activeTab === 'requirements'"
    [user]="user"
    [selectedYearChoice]="selectedYearChoice"
    [disableEditingDueToYear]="disableEditingDueToYear"
  ></app-requirements-list>
</div>
